import {actionTypes, mutationTypes} from '@/commons/constants';
import axios from 'axios';

export default {
    async [actionTypes.OBSERVADOR.INSERIR_OBSERVADORES_NOVO](context, {minutaId, observadores}) {
        return await axios.post(`api/observadores/inserir/minutas/${minutaId}`, {observadores})
    },

    async [actionTypes.OBSERVADOR.BUSCAR_OBSERVADORES]({commit}, {contratoId, minutaId}) {
        const {data} = await axios.get(`api/observadores/buscar/minutas/${minutaId}/contrato/${contratoId}/todos`)
        commit(mutationTypes.OBSERVADOR.SET_OBSERVADORES, data)
    },

    async [actionTypes.OBSERVADOR.BUSCAR_OBSERVADORES_POR_MINUTA_VERSAO](context, {minutaId, contratoId, versao}) {
        const {data} = await axios.get(`api/observadores/buscar/minutas/${minutaId}/contrato/${contratoId}/todos?versao=${versao}`)
        return data
    },

    async [actionTypes.OBSERVADOR.REMOVER_OBSERVADOR](context, {minutaId, observadorId}) {
        const {data} = await axios.delete(`api/observadores/${observadorId}/remover/minutas/${minutaId}`)
        return data
    },
}